<dx-box
    #architecturalApplicationsBox
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-grid-container"
    [elementAttr]="{ id: 'architecturalApplicationsBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <cc-data-grid-features
            #gridFeatures
            [stateConfig]="{ storageKey: 'ARCHITECTURAL_APPLICATION_SEARCH_GRID' }"
            [dataSource]="architecturalApplications"
        >
            <dx-data-grid width="100%" height="100%" [dataSource]="architecturalApplications">
                <dxo-search-panel [text]="searchText"></dxo-search-panel>

                <dxi-column dataField="project" dataType="string" caption="Project"></dxi-column>
                <dxi-column dataField="dueDate" dataType="string" caption="Due Date" [format]="dateFormat"></dxi-column>
                <dxi-column
                    dataField="createdOn"
                    dataType="string"
                    caption="Created On"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column dataField="accItemId" dataType="number" caption="Item ID"></dxi-column>
                <dxi-column dataField="description" dataType="string" caption="Description"></dxi-column>
                <dxi-column
                    dataField="propertyAddress"
                    dataType="string"
                    caption="Property Address"
                    cellTemplate="propertyAddressTemplate"
                ></dxi-column>
                <dxi-column dataField="owner" dataType="string" caption="Owner"></dxi-column>
                <dxi-column
                    dataField="accountNumber"
                    dataType="string"
                    caption="Account Number"
                    cellTemplate="accountNumberTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="community"
                    dataType="string"
                    caption="Community"
                    cellTemplate="communityTemplate"
                ></dxi-column>
                <dxi-column dataField="location" dataType="string" caption="Location"></dxi-column>

                <div *dxTemplate="let cell of 'propertyAddressTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [customerId]="cell.data.accountNumber"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let cell of 'communityTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let cell of 'accountNumberTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [customerId]="cell.data.accountNumber"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>
                <dxo-summary>
                    <dxi-group-item
                        column="accountNumber"
                        summaryType="count"
                        displayFormat="Count = {0}"
                    ></dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#architecturalApplicationsBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
